import styled from "styled-components/macro";
import brand from "@/theme/brand";

const FooterLink = styled.a`
  color: inherit;
  text-decoration: none;
  white-space: nowrap;

  :hover {
    color: black;
  }
`;

const Footer = styled((props) => {
  const isMobileApp = window.ReactNativeWebView && window.ReactNativeWebView.postMessage;

  return (
    <div {...props}>
      {brand.name} v{process.env.REACT_APP_VERSION}
      {" | "}
      {!isMobileApp && (
        <>
          <FooterLink href={`mailto:${brand.supportEmail}`}>Contact us</FooterLink>
          {" | "}
          <FooterLink href={brand.termsUrl}>Terms and Conditions</FooterLink>
          {" | "}
          <FooterLink href={brand.privacyUrl}>Privacy policy</FooterLink>
        </>
      )}
    </div>
  );
})`
  color: #9aa0ac;
  font-size: 14px;
  text-align: center;
`;

export default Footer;
